import { ServiceInitializer } from '@estee/elc-universal-utils';
import { BaseService } from '@estee/elc-service';

const { name, version } = __serviceInfo__;

export class RatingsReviewsService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}

export default {
    configStore: 'CONFIG_STORE',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    ratingsReviewsService: 'RATINGS_REVIEWS_SERVICE',
    productRatingViewController: 'PRODUCT_RATING_VIEW_CONTROLLER',
    productReviewsViewController: 'PRODUCT_REVIEWS_VIEW_CONTROLLER',
    reviewDetailsViewController: 'REVIEW_DETAILS_VIEW_CONTROLLER',
    productRepository: 'PRODUCT_REPOSITORY',
    ratingsRepository: 'RATINGS_REPOSITORY',
    ratingsReviewsApiSdk: 'REVIEW_SNIPPET_API_SDK',
    httpTransport: 'HTTP_TRANSPORT'
};
